import 'whatwg-fetch';
var Cookie = require('js-cookie');

const header = {
  'Content-Type': 'application/json',
};
const BaseUrl = '';

const controller = null; //new AbortController();
const signal = null; // controller.signal;

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  return response.json();
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else if (response.status === 403 || response.status === 404) {
    return Promise.reject(new Error('Something went wrong'));
  }

  return Promise.reject(new Error(response.statusText));
}

function get(url, body) {
  let promise = fetch(BaseUrl + url, {
    mode: 'cors',
    //      method: "GET",
    ////      credentials: 'same-origin',
    credentials: 'include',
    headers: {
      'X-CSRFToken': Cookie.get('csrftoken'),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    //      headers: header,//headers,
    //      body: JSON.stringify(body),
    //      signal
  })
    .then(checkStatus)
    .then(parseJSON);

  return [promise, controller];
}

function post(url, data) {
  data['X-CSRFToken'] = Cookie.get('csrftoken');
  let promise = fetch(BaseUrl + url, {
    method: 'POST',
    credentials: 'include',
    //      credentials: 'same-origin',
    //credentials: 'include',
    headers: {
      'X-CSRFToken': Cookie.get('csrftoken'),
      'Content-Type': 'application/json',
    }, //headers,
    body: JSON.stringify(data),
  })
    .then(checkStatus)
    .then(parseJSON);
  return [promise, controller];
}

function put(url, data) {
  data['X-CSRFToken'] = Cookie.get('csrftoken');
  let promise = fetch(BaseUrl + url, {
    method: 'PUT',
    credentials: 'include',
    //      credentials: 'same-origin',
    headers: {
      'X-CSRFToken': Cookie.get('csrftoken'),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then(checkStatus)
    .then(parseJSON);
  return [promise, controller];
}

function remove(url, body) {
  body.csrfmiddlewaretoken = Cookie.get('csrftoken');
  return fetch(BaseUrl + url, {
    method: 'DELETE',
    //      credentials: 'same-origin',
    credentials: 'include',
    headers: header, //headers,
    body: JSON.stringify(body),
  })
    .then(checkStatus)
    .then(parseJSON);
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default {
  getCall: get,
  postCall: post,
  putCall: put,
  deleteCall: remove,
};
